// src/pages/FaqSearchResultPage.jsx
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import '../styles/App.css';
import '../styles/Faq.css';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import FaqAnswer from '../components/FaqAnswer';
import {useTranslation} from "react-i18next";
import {getPath} from "../utils/functions";

function FaqSearchResultPage() {
    const [t] = useTranslation();
    const location = useLocation();
    const { results, searchQuery } = location.state || { results: null, searchQuery: "" };
    const sectionTitleKeys = {
        "general": "topic1",
        "profile-management": "topic2",
        "search-and-filtering": "topic3",
        "activities-details": "topic4",
        "booking-schedule": "topic5",
        "reviews&comments": "topic6",
    };

    return (
        <>
            <Navbar />
            <div className="container mt-4">
                <ol className="breadcrumbs">
                    <li itemScope itemType="https://schema.org/WebPage">
                <span itemProp="title" style={{color: "#2F4C72"}}><Link to={getPath("/faqs")} className=""><img
                    src="/Images/question-in-circle.png"
                    style={{width: "30px"}}/> {t('faqs.topics')}</Link></span>
                    </li>
                    <li itemScope itemType="https://schema.org/WebPage">
                <span itemProp="title"
                      style={{color: "#28AFb0"}}>{t('faqs.search_results')}</span>
                    </li>
                </ol>
                <h2 style={{color: "#2F4C72"}}>{t('faqs.search_results_for')} "{searchQuery}"</h2>
                {results && Object.keys(results).length > 0 ? (
                    Object.keys(results).map(section => (
                        <div key={section} className="search-result-section">
                            <h3>{t(`faqs.${sectionTitleKeys[section]}`)}</h3>
                            {Object.keys(results[section]).map(category => (
                                <div key={category} className="search-result-category">
                                    <h4>{category}</h4>
                                    <ul>
                                        {results[section][category].map((faq, index) => (
                                            <li key={index} className="faq-item">
                                                <strong>{faq.question}</strong>
                                                <p><FaqAnswer faq={faq} /></p>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            ))}
                        </div>
                    ))
                ) : (
                    <h3 style={{color: "#2F4C72"}}>{t('faqs.no_results_found')} "{searchQuery}"</h3>
                )}
            </div>
            <Footer/>
        </>
    );
}

export default FaqSearchResultPage;
